import  { useEffect } from "react";
import { Layout, message } from "antd";
import "./App.css";
import styled from "styled-components";
import useCourseStore from "../store/course";
import useBucketStore from "../store";
import api, { authorizeApi, COURSES_URL,  studioApi } from "../api";
import { ICourse } from "../screens/list";
import SideBar from "./sideBar";
import { IConfig, ISetting } from "../interfaces";
import { useMediaQuery } from "react-responsive";
import { useRouterState } from "@tanstack/react-router";

const { Content } = Layout;

const isAuthenticated = () => {
  const token = localStorage.getItem("AUTH_TOKEN");
  return token;
};

function DashboardLayout({
  showSideBar = true,
  children,
  defalutSelectedKey,
}: any) {
  const { setCourses } = useCourseStore();
  const { createBucket, setError } = useBucketStore();
  const token = localStorage.getItem("AUTH_TOKEN");
  const location = window.location.pathname;

  const fetchConfig = async () => {
    try {
      const { data } = await studioApi.get<IConfig[]>("buckets");
      createBucket(data);
    } catch (e: any) {
      message.error(e.message);
    }
  };

  const getCourses = async () => {
    try {
      const { data } = await api.get<ICourse[]>(COURSES_URL);
      setCourses(data);
    } catch (e: any) {
      setError(e.message);
    }
  };
  const getSettings = async () => {
    try {
      const { data } = await studioApi.get<ISetting[]>("settings");
      data.forEach((bucket) => {
        // localStorage.setItem(bucket.name, bucket.value);
      });
    } catch (e: any) {
      message.error(e.message);
      console.log({ e });
    }
  };

  useEffect(() => {
    getCourses();
    authorizeApi()
    if (token && location !== "/login") {
      getSettings();
      fetchConfig();
    }
  }, []);

  const isMobile = useMediaQuery({
    query: "(max-width: 769px)",
  });
  const pathname = useRouterState().location.pathname;
  const isPublicRoute =
  pathname === "/" || pathname === "/login" || pathname==="/privacy-policy";

  return (
    <Layout className="layout-container">
      {!isPublicRoute && isAuthenticated() && !isMobile && (
        <SideBar defaultSelectedKeys={defalutSelectedKey} />
      )}
      <Layout>
      {isPublicRoute ? (
    <PublicContent>{children}</PublicContent>
  ) : (
    <ContentContainer>{children}</ContentContainer>
  )}
      </Layout>
    </Layout>
  );
}

// const LogoContainer = styled.div`
//   font-size: 25px;
//   display: flex;
//   align-items: flex-end;
//   padding: 10px;
//   margin: 5px;
//   border-radius: 10px;
//   color: white;
// `;

const ContentContainer = styled(Content)`
  background: white;
  margin: 10px;
  border-radius: 10px;
  background: white;
  box-shadow:
    -13px -13px 26px #dedede,
    13px 13px 26px #ffffff;
  overflow-y: scroll;
  overflow-x: hidden;
`;

const PublicContent = styled(Content)`
  margin: 0;
  padding: 0;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
`;

export default DashboardLayout;
